import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private UserProps = new BehaviorSubject<any>('');
  public UserValues: Observable<any> = this.UserProps.asObservable();

  constructor(
    private http: HttpClient) {
  }
  
init(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      fetch('/assets/appsettings.json')
        .then((response) => response.json())
        .then(async (appSetting) => {
          
          this.http.get('https://graph.microsoft.com/v1.0/me')
            .subscribe(value => {
              this.UserProps.next(value);
              resolve(true);
            },
              (error) => {
                reject(error);
              });
        });
    });
  }

  public setUser(user: any) {
    this.UserProps.next(user);
    /*
        this.http.get('https://graph.microsoft.com/v1.0/me')
            .subscribe(value => {
              
            },
              (error) => {
                //do something
              });
              */
  }
}
